<template>
  <div class="room">
    <div class="titleWrap">
      <div class="setTitle">房间列表</div>
      <!-- <el-button class="myBtn" type="primary" plain size="small" :disabled="delStatus" @click="remove" style="margin-left: 10px;">批量删除</el-button> -->
      <el-upload class="myBtn" :action="importRoomUrl" :headers="myHeaders" :show-file-list="false" accept=".xls, .xlsx" :on-success="uploadSuccess" :on-error="uploadError" style="margin-left: 10px;">
        <el-button type="primary" plain size="small" v-if="villageId !== '' && funcData.indexOf('import') > -1">导入</el-button>
      </el-upload>
      <el-button class="myBtn" type="primary" plain size="small" v-if="villageId !== '' && funcData.indexOf('import') > -1" @click="templateRoom" style="margin-left: 10px;">房间模板</el-button>
      <el-button class="myBtn" type="primary" size="small" v-if="villageId !== '' && funcData.indexOf('add') > -1" @click="add">新增</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-select class="select" v-model="villageValue" filterable size="small" placeholder="小区名称" @change="changeSearchVillage" v-if="villageId === ''">
        <el-option v-for="item in villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
      </el-select>
      <el-input class="input" v-model.trim="villageName" disabled size="small" placeholder="小区名称" v-else></el-input>
      <el-select class="select" v-model="building" filterable clearable size="small" placeholder="楼栋" @change="changeSearchBuilding">
        <el-option v-for="item in buildingList" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-select class="select" v-model="unit" filterable clearable size="small" placeholder="单元">
        <el-option v-for="item in unitList" :key="item.id" :label="item.value" :value="item.id"></el-option>
      </el-select>
      <el-input class="input" v-model.trim="floor" size="small" placeholder="楼层"></el-input>
      <el-input class="input" v-model.trim="room" size="small" placeholder="房间号"></el-input>
      <!-- <el-select class="select" v-model="doorValue" filterable clearable size="small" placeholder="电梯门">
        <el-option v-for="item in doorList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select> -->
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <div class="clearfix"></div>
      <el-table :data="roomAttr" class="list" @selection-change="selectRoom">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="orgName" label="小区名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="building" label="楼栋" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.building }}栋
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单元" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.unit }}单元
          </template>
        </el-table-column>
        <el-table-column prop="floor" label="楼层" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.floor }}楼
          </template>
        </el-table-column>
        <el-table-column prop="room" label="房间号" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="door" label="电梯门" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ doorType(scope.row.door) }}
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ createTime(scope.row.createDate) }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" min-width="120" label="操作" v-if="villageId !== ''">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="villageId !== '' && funcData.indexOf('edit') > -1" @click="edit(scope.row.id)">编辑</el-button>
            <el-button type="text" size="small" v-if="villageId !== '' && funcData.indexOf('delete') > -1" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="roomCurr" :page-sizes="[10, 20, 50]" :page-size="roomSize" :total="roomTotal" @current-change="roomCurrChange" @size-change="roomSizeChange"></el-pagination>
    </el-main>
    <!-- 新增编辑房间弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px" size="small">
        <el-form-item label="小区名称" prop="village" v-if="villageId === ''">
          <el-select class="select" v-model="form.village" filterable clearable :disabled="form.isEdit" size="small" placeholder="小区名称" @change="changeVillage">
            <el-option v-for="item in form.villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区名称" :required="true" v-else>
          <el-input v-model.trim="villageName" disabled placeholder="小区名称"></el-input>
        </el-form-item>
        <el-form-item label="楼栋" prop="building">
          <el-select class="select" v-model="form.building" filterable clearable placeholder="楼栋" @change="changeBuilding">
            <el-option v-for="item in form.buildingList" :key="item.id" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单元" prop="unit">
          <el-select class="select" v-model="form.unit" filterable clearable placeholder="单元">
            <el-option v-for="item in form.unitList" :key="item.id" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层" prop="floor">
          <el-input v-model.trim="form.floor" placeholder="楼层"></el-input>
        </el-form-item>
        <el-form-item label="房间" prop="room">
          <el-input v-model.trim="form.room" placeholder="房间"></el-input>
        </el-form-item>
        <el-form-item label="电梯门" prop="door">
          <el-select class="select" v-model="form.door" filterable clearable placeholder="电梯门">
            <el-option v-for="item in form.doorList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="okBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入错误信息弹出层 -->
    <el-dialog :visible.sync="infoDialog" :title="infoTitle" width="600px" :close-on-click-modal="false" @close="infoNotBtn">
      <el-table class="infoList" :data="infoList">
        <el-table-column prop="index" label="列表行数" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="info" label="错误信息" min-width="300" :align="align"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Room',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      importRoomUrl: this.$url + this.$api.room_import, // 房间导入的地址
      myHeaders: {
        token: sessionStorage.getItem('token') // token数据
      },
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      villageValue: '', // 小区名称下拉菜单选中value
      villageList: [], // 小区名称下拉菜单
      building: '', // 楼栋编号下拉菜单选中value
      buildingList: [], // 楼栋编号下拉菜单
      unit: '', // 单元编号下拉菜单选中value
      unitList: [], // 单元编号下拉菜单
      floor: '', // 楼层查询输入框
      room: '', // 房间查询输入框
      doorValue: '', // 电梯门下拉菜单选中value
      doorList: [], // 电梯门下拉菜单
      delStatus: true, // 批量删除按钮的状态
      roomAttr: [], // 房间列表
      roomTotal: 0, // 房间总数
      roomSize: 10, // 房间每页条数
      roomCurr: 1, // 房间当前页数
      selectRoomArr: [], // 选中的房间数组
      dialog: false, // 房间弹出层状态
      title: '', // 房间弹出层标题
      loading: false, // 房间弹出层确定按钮loading
      form: {
        roomId: '', // 房间Id
        village: '', // 小区名称
        villageList: [], // 小区名称下拉框
        building: '', // 楼栋
        buildingList: [], // 楼栋下拉框
        unit: '', // 单元
        unitList: [], // 单元下拉框
        floor: '', // 楼层
        room: '', // 房间
        door: '', // 电梯门
        doorList: [] // 电梯门下拉框
      },
      rules: {
        village: [
          {
            required: true,
            message: '请选择小区名称',
            trigger: 'change'
          }
        ],
        building: [
          {
            required: true,
            message: '请选择楼栋',
            trigger: 'change'
          }
        ],
        unit: [
          {
            required: true,
            message: '请选择单元',
            trigger: 'change'
          }
        ],
        floor: [
          {
            required: true,
            message: '请输入楼层',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z]+$/
              if (!reg.test(value)) {
                callback(new Error('楼层由英文和数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        room: [
          {
            required: true,
            message: '请输入房间',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z]+$/
              if (!reg.test(value)) {
                callback(new Error('房间由英文和数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        door: [
          {
            required: true,
            message: '请选择前后门',
            trigger: 'change'
          }
        ]
      },
      infoDialog: false, // 导入错误信息弹出层状态
      infoTitle: '导入错误信息', // 导入错误信息弹出层标题
      infoList: [] // 导入错误信息列表
    }
  },
  computed: {
    // 功能权限
    funcData () {
      let data = this.$store.state.menus.funcData
      let buttonArr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].url === this.$store.state.menus.activeMenu) {
          buttonArr.push(data[i].funcBotton)
        }
      }
      return JSON.parse(JSON.stringify(buttonArr))
    }
  },
  mounted () {
    // 小区名称
    if (this.$store.state.user.villageId === '') {
      this.villageId = ''
      this.villageName = ''
    } else {
      this.villageId = this.$store.state.user.villageId
      this.villageName = this.$store.state.user.villageName

      // 获取楼栋下拉菜单
      this.$http.get(this.$api.building_list, {
        params: {
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          for (let i = 0; i < data.data.data.length; i++) {
            this.form.buildingList.push({
              id: data.data.data[i],
              value: data.data.data[i] + '栋'
            })
            this.buildingList.push({
              id: data.data.data[i],
              value: data.data.data[i] + '栋'
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }

    // 获取小区名称下拉菜单
    this.$http.get(this.$api.village_list, {
      params: {
        pageSize: 9999,
        pageNum: 1
      }
    }).then((res) => {
      let data = res.data

      if (data.success) {
        this.villageValue = data.data.list[0].id
        this.villageList = data.data.list
        this.form.villageList = data.data.list

        // 获取电梯列表数据
        this.getRoomList(this.roomCurr, this.roomSize)
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    // 获取电梯门下拉框数据
    this.doorList = [
      {
        key: 'front',
        value: '前门'
      },
      {
        key: 'back',
        value: '后门'
      }
    ]
    this.form.doorList = [
      {
        key: 'front',
        value: '前门'
      },
      {
        key: 'back',
        value: '后门'
      }
    ]
    // 获取楼层对应规则列表
    if (this.villageId !== '') {
      this.$http.get(this.$api.floor_rule_select, {
        params: {
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.form.floorRuleList = data.data.data
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  methods: {
    getRoomList (page, size) {
      let params
      if (this.villageId === '') {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageValue,
          building: this.building,
          unit: this.unit,
          floor: this.floor,
          room: this.room
        }
      } else {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageId,
          building: this.building,
          unit: this.unit,
          floor: this.floor,
          room: this.room
        }
      }
      this.$http.get(this.$api.room_list, {
        params: params
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.roomAttr = data.data.list
          this.roomTotal = data.data.total
          this.roomSize = size
          this.roomCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getRoomList(1, this.roomSize)
    },
    add () {
      if (this.villageId === '') {
        this.form.buildingList = []
      }
      this.dialog = true
      this.title = '新增房间'
    },
    edit (id) {
      /* 房间详情--开始 */
      this.$http.get(this.$api.room_detail, {
        params: {
          id: id
        }
      }).then((res) => {
        let detailData = res.data

        if (detailData.data.success) {
          /* 楼栋下拉框--开始 */
          this.$http.get(this.$api.building_list, {
            params: {
              orgId: detailData.data.data.orgId
            }
          }).then((res) => {
            let buildingData = res.data

            if (this.villageId === '') {
              this.form.buildingList = []
              for (let i = 0; i < buildingData.data.data.length; i++) {
                this.form.buildingList.push({
                  id: buildingData.data.data[i],
                  value: buildingData.data.data[i] + '栋'
                })
              }
            }

            if (buildingData.data.success) {
              /* 单元下拉框--开始 */
              this.$http.get(this.$api.unit_list, {
                params: {
                  orgId: detailData.data.data.orgId,
                  building: detailData.data.data.building
                }
              }).then((res) => {
                let unitData = res.data

                if (unitData.data.success) {
                  for (let i = 0; i < unitData.data.data.length; i++) {
                    this.form.unitList.push({
                      id: unitData.data.data[i],
                      value: unitData.data.data[i] + '单元'
                    })
                  }
                  this.form.floorRuleList = buildingData.data.data
                  this.form.roomId = id
                  this.form.village = detailData.data.data.orgId
                  this.form.building = detailData.data.data.building
                  this.form.unit = detailData.data.data.unit
                  this.form.floor = Number(detailData.data.data.floor)
                  this.form.room = detailData.data.data.room
                  this.form.door = detailData.data.data.door
                  this.dialog = true
                  this.title = '编辑房间'
                } else {
                  this.$message({
                    type: 'error',
                    message: unitData.data.errMsg,
                    duration: 1000
                  })
                }
              }).catch((err) => {
                console.log(err)
              })
              /* 单元下拉框--结束 */
            } else {
              this.$message({
                type: 'error',
                message: buildingData.data.errMsg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
          /* 楼栋下拉框--结束 */
        } else {
          this.$message({
            type: 'error',
            message: detailData.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
      /* 房间详情--结束 */
    },
    remove (id) {
      this.$confirm('是否删除房间?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = new FormData()
        formData.append('id', id)

        this.$http({
          method: 'post',
          url: this.$api.room_remove,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.$message({
              message: '房间已删除',
              type: 'success',
              duration: 1000
            })
            this.getRoomList(1, this.roomSize)
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    templateRoom () {
      window.open(this.$url + this.$api.import_template + '?type=4')
    },
    uploadSuccess (res) {
      if (res.success) {
        if (res.data.length === 0) {
          this.$message({
            message: '导入房间成功',
            type: 'success',
            duration: 1000
          })
        } else {
          this.$message({
            message: '导入房间完成',
            type: 'success',
            duration: 1000
          })
          for (let i = 0; i < res.data.length; i++) {
            for (let k in res.data[i]) {
              this.infoList.push({
                index: k,
                info: res.data[i][k]
              })
            }
          }
          this.infoDialog = true
        }
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
          duration: 2000
        })
      }
      this.getRoomList(this.roomCurr, this.roomSize)
    },
    uploadError () {
      this.$message({
        type: 'error',
        message: '导入房间失败',
        duration: 1000
      })
    },
    infoNotBtn () {
      this.infoDialog = false
      this.infoList = []
    },
    changeSearchVillage (val) {
      this.building = ''
      this.unit = ''
      this.buildingList = []
      this.unitList = []
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.building_list, {
          params: {
            orgId: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.buildingList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '栋'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeSearchBuilding (val) {
      this.unit = ''
      this.unitList = []
      let myOrg = ''
      if (this.villageId === '') {
        myOrg = this.villageValue
      } else {
        myOrg = this.villageId
      }
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.unit_list, {
          params: {
            orgId: myOrg,
            building: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.unitList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '单元'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeVillage (val) {
      this.form.building = ''
      this.form.unit = ''
      this.form.buildingList = []
      this.form.unitList = []
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.building_list, {
          params: {
            orgId: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.form.buildingList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '栋'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeBuilding (val) {
      this.form.unit = ''
      this.form.unitList = []
      let myOrg = ''
      if (this.villageId === '') {
        myOrg = this.form.village
      } else {
        myOrg = this.villageId
      }
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.unit_list, {
          params: {
            orgId: myOrg,
            building: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.form.unitList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '单元'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    notBtn () {
      this.loading = false
      this.form.roomId = ''
      this.$refs.form.resetFields()
      this.dialog = false
      this.form.village = ''
      this.form.building = ''
      this.form.unit = ''
      this.form.unitList = []
      this.form.floor = ''
      this.form.room = ''
      this.form.door = ''
    },
    okBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true

          let formData = new FormData()
          formData.append('id', this.form.roomId)
          if (this.villageId === '') {
            formData.append('orgId', this.form.village)
          } else {
            formData.append('orgId', this.villageId)
          }
          formData.append('building', this.form.building)
          formData.append('unit', this.form.unit)
          formData.append('floor', this.form.floor)
          formData.append('room', this.form.room)
          formData.append('door', this.form.door)

          if (this.form.roomId === '') {
            this.$http({
              method: 'post',
              url: this.$api.room_add,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '新增房间成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getRoomList(this.roomCurr, this.roomSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
              this.loading = false
            }).catch((err) => {
              this.loading = false
              console.log(err)
            })
          } else {
            this.$http({
              method: 'post',
              url: this.$api.room_edit,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '编辑房间成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getRoomList(this.roomCurr, this.roomSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
              this.loading = false
            }).catch((err) => {
              this.loading = false
              console.log(err)
            })
          }
        } else {
          return false
        }
      })
    },
    roomCurrChange (curr) {
      this.getRoomList(curr, this.roomSize)
    },
    roomSizeChange (size) {
      this.getRoomList(this.roomCurr, size)
    },
    selectRoom (selection) {
      if (selection.length > 0) {
        this.delStatus = false
        this.selectRoomArr = []
        for (let i = 0; i < selection.length; i++) {
          this.selectRoomArr.push(selection[i].id)
        }
      } else {
        this.delStatus = true
      }
    },
    doorType (val) {
      for (let i = 0; i < this.doorList.length; i++) {
        if (val.toString() === this.doorList[i].key) {
          return this.doorList[i].value
        }
      }
    },
    createTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2) + ' ' + time.substr(11, 2) + ':' + time.substr(14, 2) + ':' + time.substr(17, 2)
      }
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.roomCurr - 1) * this.roomSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.room
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-top 12px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .input
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .searchBtn
      float left
      margin-top 8px
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select
          width 100%
      .infoList
        width 100%
        thead
          tr, th
            padding 4px 0
            color #666
            background-color #fafafa
            .cell
                font-weight bold
        tbody
          tr, th
            color #333
        td
          padding 7px 0
        .cell
          line-height 26px
</style>



// WEBPACK FOOTER //
// src/components/room/room.vue